export default "__VITE_ASSET__5m0vuG8T__"